import React, { useEffect, useState } from "react";
// import { useNavigate, useLocation, Link } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import {
  decryptData,
  encryptData,
  isValidEmail,
} from "../utils/HelperFunction";
import httpRequest from "../utils/Http";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { login } from "../reducers/auth";
import { useDispatch } from "react-redux";
import "./Login.css";
import { COMPANY } from "../constant/company_constant";

const Login = () => {
  //   const [sessionId, setSessionId] = useState("");
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);
  //   const navigate = useNavigate();
  const location = useLocation();
  let dispatch = useDispatch();

  const onSubmitHandler = (e) => {
    e.preventDefault();
    // console.log(formData);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (values) => {
    const errors = {};

    if (!values.emailId) {
      if (!isValidEmail(values.emailId)) {
        errors.emailId = "Enter email id";
      }
    } else if (!values.password) {
      errors.password = "Enter password";
    }

    if (values.emailId) {
      if (!isValidEmail(values.emailId)) {
        errors.emailId = "Enter valid email id";
      }
    }

    return errors;
  };

  useEffect(() => {
    //  console.log(formData);
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      (async () => {
        const data = await httpRequest(
          "login",
          {
            ...formData,
          },
          "POST",
        );
        //console.log(data);
        if (data.status === true && data.message) {
          setSubmit(false);

          dispatch(
            login({
              token: data.message,
            }),
          );
          toast.success("Authentication Successful");
          window.location.reload();
        } else {
          toast.error(data.message);
          setFormErrors({ inputType: data.message });
          //   console.log(data.message);
        }
      })();
    }
    //eslint-disable-next-line
  }, [formErrors, isSubmit]);

  return (
    <main className="auth-page">
      <section className="auth-brand-panel" aria-label={COMPANY.name}>
        <Link to={"/"} className="auth-logo">
          <img src={COMPANY.logo} alt={COMPANY.name} />
        </Link>
        <div className="auth-brand-content">
          <h1>{COMPANY.tagline}</h1>
          <p>{COMPANY.description}</p>
          <div className="auth-benefits">
            <div className="auth-benefit">
              <i className="fas fa-bolt" /> Fast booking management
            </div>
            <div className="auth-benefit">
              <i className="fas fa-chart-line" /> Clear operational visibility
            </div>
            <div className="auth-benefit">
              <i className="fas fa-shield-alt" /> Secure role-based access
            </div>
          </div>
        </div>
        <div className="auth-copyright">
          &copy; {COMPANY.copyrightYear} {COMPANY.name}. All rights reserved.
        </div>
      </section>
      <section className="auth-form-panel">
        <div className="auth-card">
          <div className="auth-kicker">Welcome back</div>
          <h2>Sign in to your account</h2>
          <p className="auth-subtitle">
            Enter your credentials to continue to {COMPANY.name}.
          </p>
          <form onSubmit={onSubmitHandler} method="post" className="auth-form">
            <div className="auth-field">
              <label className="auth-label" htmlFor="emailId">
                Email address
              </label>
              <div className="auth-input-control">
                <input
                  type={"email"}
                  className={
                    !formErrors.emailId ? "auth-input" : "auth-input is-invalid"
                  }
                  placeholder={"Email"}
                  name={"emailId"}
                  id="emailId"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    });
                  }}
                />
                <i
                  className="fas fa-envelope auth-input-icon"
                  aria-hidden="true"
                />
              </div>
              {formErrors.emailId && (
                <div className="auth-error">{formErrors.emailId}</div>
              )}
            </div>
            <div className="auth-field">
              <label className="auth-label" htmlFor="password">
                Password
              </label>
              <div className="auth-input-control">
                <input
                  type="password"
                  className={
                    !formErrors.password
                      ? "auth-input"
                      : "auth-input is-invalid"
                  }
                  placeholder="Password"
                  name="password"
                  id="password"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      [e.target.name]: e.target.value,
                    });
                  }}
                />
                <i className="fas fa-lock auth-input-icon" aria-hidden="true" />
              </div>
              {formErrors.password && (
                <div className="auth-error">{formErrors.password}</div>
              )}
            </div>
            {formErrors.inputType && (
              <div className="auth-error">{formErrors.inputType}</div>
            )}
            <button type="submit" className="auth-submit">
              Sign in
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default Login;
